import React, { useContext } from 'react'
import "./TypeBadge.css"
import { newsType } from '../Network/News'
import { LanguageContext } from '../Language/LanguageContext'

function TypeBadge(props) {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news

    const typeBadge = (type) =>{
        switch(type){
            case(newsType.VOTE):
                return lang.vote
            case(newsType.QUIZ):
                return lang.quiz
            case(newsType.INFORM):
                return lang.inform
            case(newsType.REGISTER):
                return lang.register
            default:
                return lang.general
        }
    }

    const typeBadgeColor = (type) =>{
        switch(type){
            case(newsType.VOTE):
                return "rgb(0, 61, 165)"
            case(newsType.QUIZ):
                return "rgb(255, 80, 0)"
            case(newsType.INFORM):
                return "rgb(77, 77, 77, 0.78)"
            case(newsType.REGISTER):
                return "rgb(117,93, 70)"
            default:
                return "#efb729"
        }
    }

    return (
        <div className="badge-type" 
        style={{
            backgroundColor: typeBadgeColor(props.type)
        }}>
            {typeBadge(props.type)}
        </div>
    )
}

export default TypeBadge
